<template lang="pug">
div
  notifications(group="status" position="top center")
  header.public-header.row.justify-content-md-center
    b-col(md="10")
      a(href="https://www.recorrido.cl/es/" target="_blank")
        img.recorrido-logo(:src="logo")
  b-row.justify-content-md-center(v-if="complaint.aasm_state" style="padding-top: 25px")
    b-col(md="10")
      h3 Reclamo \#{{ complaint.number }}
        span.complaint-category {{ complaint.complaint_category.name }}
      div.complaint-wizard
        ol.complaint-wizard-steps
          li.a-wizard-step
            span.step-number 1
            | Reclamo ingresado
          li.a-wizard-step
            span.step-number 2
            | En revisión
          li.a-wizard-step
            span.step-number 3
            | {{ complaint.aasm_state === 'expired' ? 'Expirado' : 'Resuelto' }}
      div.complaint-category-container(v-if="complaint.category")
        p(v-if="complaint.category === 8")
          strong Hola equipo Busbud,
            span(v-if="wizard_status === 'review'")
              br
              | Hemos recibido su requerimiento y ha sido ingresado con el ID {{ complaint.number }}. Nos pondremos en contacto con la empresa de buses y volveremos con una respuesta a través de este mismo medio.
            span(v-if="wizard_status === 'resolved'")  el reclamo ha sido resuelto.
        p(v-else)
          strong {{ setFormalOpening }} {{ issuer_name }},
            span(v-if="wizard_status === 'review'")  su reclamo se encuentra en revisión.
            span(v-if="wizard_status === 'resolved'")  su reclamo {{ complaint.aasm_state === 'expired' ? 'ha expirado.': 'se ha resuelto.' }}
      p Número de compra: {{ complaint.ticket_info.booking_number }}
        br
        | Fecha ingreso de reclamo: {{ customFormat(complaint.created_at) | formatDate }}
        br
        | Fecha actualización de reclamo: {{ customFormat(complaint.updated_at) | formatDate }}
        br
      div(v-if="this.complaint.additional_infos.length > 0 && complaint.aasm_state === 'pending_requested'").requested-information-notice
        img.request-icon(:src="requestIcon")
        p
          strong Información adicional requerida
          br
          | Para poder solucionar su reclamo, necesitamos información adicional.
          br
          a.inline-dark-link(href="#" ,@click.prevent="openInformationRequestTab") Haga clic aquí
          |  para subir la información adicional solicitada al sistema.
      .resolved-status-container
        div(v-if="complaint.aasm_state === 'expired'")
          h4
            img(:src="rejectIcon")
            span Reclamo expirado.
          p
            img(:src="messageIcon")
            | {{ this.getExpiredMessage() }}
        div(v-if="complaint.aasm_state === 'rejected'")
          h4
            img(:src="rejectIcon")
            span Reclamo rechazado.
          p
            img(:src="messageIcon")
            strong(v-html="complaint.response.comment")
        div(v-if="complaint.aasm_state === 'approved_bank' && complaint.reimbursement")
          h4
            img(:src="approveIcon")
            | Reclamo aprobado.
            br
            | Monto devolución:&nbsp;
            | {{ complaint.reimbursement.amount }} {{ complaint.ticket_info.sold_currency }}
          p(v-if="complaint.reimbursement.comment")
            img(:src="messageIcon")
            strong.reimbursement(v-html="complaint.reimbursement.comment")
        div(v-if="complaint.aasm_state === 'closed' && complaint.reimbursement && complaint.reimbursement.compensation_type === 'o'")
          h4
            img(:src="approveIcon")
            | Reclamo aprobado.
            br
          p(v-if="complaint.response.comment")
            img(:src="messageIcon")
            strong.reimbursement(v-html="complaint.response.comment")
        div(v-if="complaint.aasm_state === 'closed' && complaint.reimbursement && complaint.reimbursement.compensation_type === 'm'")
          h4
            img(:src="approveIcon")
            | Reclamo aprobado.
      div.update-status
        p.update-message(v-if="complaintOlderThanAWeek && wizard_status !== 'resolved'")
          | Ya insistimos con la empresa de bus para obtener una resolución lo antes posible.
          br
          | Lamentablemente aún no tenemos respuesta.
          br
          | Una vez que tengamos respuesta de la empresa de bus, le contactaremos.
        div(v-if="complaint.aasm_state === 'approved_bank' || complaint.aasm_state === 'reimbursement_error'")
          div(v-if="complaint.refund_method !== 'payroll_paypal'")
            h4 Ingresa tus datos bancarios
            status-bank-account-form(:complaint="complaint" @fetchComplaint="fetchComplaint")
          div(v-else)
            h4 Actualiza tu cuenta de PayPal
            b-form.form-horizontal(@submit.prevent="handleUpdatePaypalAccount")
              b-form-group(label="Correo PayPal")
                b-form-input.form-control(
                  v-model="paypal_email"
                  v-validate="'required|email'"
                  name="paypal_email"
                  data-vv-as="Correo PayPal"
                  type="email"
                  autocomplete="off"
                )
                span.has-error(v-show="errors.has('paypal_email')") {{ errors.first('paypal_email') }}
                b-form-group(label="Confirma tu correo Paypal")
                  b-form-input.form-control(
                    v-model="paypal_email_confirmation"
                    v-validate="'required|email|confirmed:paypal_email'"
                    name="paypal_email_confirmation"
                    data-vv-as="Confirma tu correo Paypal"
                    type="email"
                    autocomplete="off"
                  )
                  span.has-error(v-show="errors.has('paypal_email_confirmation')") {{ errors.first('paypal_email_confirmation') }}
                b-form-group.text-center
                b-button(type="submit" variant="primary") Ingresar
      h4.complaint-details-title(v-if="complaint.ticket_info && complaint.ticket_info.tickets.length > 0") Detalles de su reclamo
      b-tabs
        b-tab(title="Pasaje")
          table.table(v-if="complaint.ticket_info && complaint.ticket_info.tickets.length > 0")
            tr(v-show="complaint.ticket_info.tickets.length > 0")
              td Pasajes afectados
              td {{ complaint.ticket_info.tickets.join(', ') }}
            tr
              td Empresa(s)
              td {{ complaint.ticket_info.bus_operators | formatOperator }}
            tr
              td Fecha de salida (Ida)
              td {{ complaint.ticket_info.departure | formatDate }}
            tr
              td Hora de salida (Ida)
              td {{ complaint.ticket_info.departure | formatHour }}
            tr(v-if="complaint.ticket_info.arrival")
              td Fecha de salida (Vuelta)
              td {{ complaint.ticket_info.arrival | formatDate }}
            tr(v-if="complaint.ticket_info.arrival")
              td Hora de salida (Vuelta)
              td {{ complaint.ticket_info.arrival | formatHour }}
            tr
              td Método de pago
              td {{ complaint.ticket_info.payment_method }}
            tr
              td Precio
              td {{ complaint.ticket_info.price }} {{ complaint.ticket_info.sold_currency }}
        b-tab#tab-information-request(v-if="this.complaint.additional_infos.length > 0"
          title="Solicitudes de información")
          b-list-group
            input#requestFile(type="file" ,@change="uploadFile()" hidden)
            hr
            b-list-group-item(v-for="r in this.complaint.additional_infos" ,:key="r.name")
              icon(name="inbox")
              span(v-html="r.request")
              b-button.float-right(v-if="r.url === null" variant="primary" ,@click="addFile(r._id.$oid)")
                icon(name="paperclip")
                |  Adjuntar
              a.float-right(v-if="r.url !== null" ,:href="r.url") {{ `${r.name}.${r.format}` }}
      .disclaimer(v-if="wizard_status !== 'resolved' && !([3, 6, 7, 9].includes(complaint.category))")
        p {{ $t('status.disclaimer.advise') }}
        p {{ $t('status.disclaimer.contact') }}
  icon.loading-section(name="spinner" scale="5" pulse v-else)
  b-modal(ref='paypalModal' size="lg" hide-header hide-footer no-close-on-backdrop=true)
    div.modal-body
      p.text-center.cancellation-modal-success-icon
        icon(name="check" scale="5")
      p.text-center Hemos recibido su cuenta PayPal exitosamente. Por favor revise su correo electrónico.
      br
      br
      p.text-center
        b-button.btn.btn-recorrido(@click="closeModal") Cerrar
</template>

<script>
import kexaApi from '@/services/apiService';
import constants from '@/constants/Status.constants';
import generalLogo from '@/assets/img/recorrido-logo-monochrome-black.svg';
import rejectIcon from '@/assets/img/reject-icon.svg';
import approveIcon from '@/assets/img/approve-icon.svg';
import messageIcon from '@/assets/img/message-icon.svg';
import transferIcon from '@/assets/img/transfer-icon.svg';
import requestIcon from '@/assets/img/request-icon.png';
import StatusBankAccountForm from '@/components/forms/StatusBankAccountForm';
import dateService from '@/utils/dateService';

export default {
  name: 'status',
  data() {
    return {
      accounts: [],
      bank_info: {},
      banks: constants.BANKS,
      complaint: {},
      rejectIcon,
      approveIcon,
      messageIcon,
      transferIcon,
      requestIcon,
      payment_method: '',
      wizard_status: '',
      max: 16,
      paypal_email_confirmation: '',
      paypal_email: '',
    };
  },
  beforeMount() {
    this.fetchComplaint();
  },
  components: {
    StatusBankAccountForm,
  },
  computed: {
    complaintOlderThanAWeek() {
      return dateService.isAfterAWeek(this.complaint.created_at);
    },
    issuer_name() {
      const name = (this.complaint.source === 'voice') ? this.complaint.ticket_info.fullname : (this.complaint.issuer_name || 'cliente');
      return name;
    },
    setFormalOpening() {
      let formalOpening = 'Estimad';
      if (this.complaint.issuer_gender === null) {
        formalOpening += 'o/a';
      } else if (this.complaint.issuer_gender === 'male') {
        formalOpening += 'o';
      } else if (this.complaint.issuer_gender === 'female') {
        formalOpening += 'a';
      }
      return formalOpening;
    },
    logo() {
      return generalLogo;
    },
  },
  methods: {
    handleUpdatePaypalAccount() {
      const $this = this;
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if ($this.paypal_email === $this.complaint.reimbursement.paypal_email) {
            this.$dialog.confirm('El pago a esta cuenta de paypal fue rechazado anteriormente, ¿está seguro de querer ingresar esta cuenta nuevamente?', this.dialogOptions)
              .then(() => {
                this.updatePaypalAccount();
              });
          } else {
            this.updatePaypalAccount();
          }
        }
      });
    },
    updatePaypalAccount() {
      const $this = this;
      kexaApi.status_paypal_account($this.$route.params.complaint_id, {
        paypal_account: $this.paypal_email,
      }).then(() => {
        $this.$refs.paypalModal.show();
      }).catch(() => { });
    },
    closeModal() {
      this.$refs.paypalModal.hide();
      this.fetchComplaint();
    },
    fetchComplaint() {
      const $this = this;
      kexaApi.status(this.$route.params.complaint_id)
        .then((data) => {
          $this.complaint = data.body;
          if ($this.complaint.bank_account === null && $this.complaint.country === 'CL') {
            $this.complaint.bank_account = {
              account_type: 0,
            };
          }
          document.title = `Reclamo #${$this.complaint.number} | Kexa`;
          setTimeout(() => $this.activeClass(), 0);
          if (process.env.NODE_ENV === 'production') {
            this.$ga.page(this.$router);
            this.$ga.event('public_view', 'pageview', `Reclamo #${$this.complaint.number}`);
          }
        });
    },
    addFile(id) {
      document.getElementById('requestFile').click();
      this.request_id = id;
    },
    uploadFile() {
      const formData = new FormData();
      formData.append('request_id', this.request_id);
      formData.append('file', document.getElementById('requestFile').files[0]);
      kexaApi.status_submit(this.$route.params.complaint_id, formData).then(() => {
        this.fetchComplaint();
      }).catch(() => {
        this.$notify({
          group: 'status',
          type: 'error',
          title: 'Error',
          text: 'Ocurrió un error al subir el archivo',
          duration: 3000,
        });
      });
    },
    activeClass() {
      const wizardActiveStep = 'active-step';
      const thirdGroup = ['approved_bank', 'approved_reimbursement', 'approved_communication', 'closed', 'rejected', 'expired'];
      const currentAasmState = this.complaint.aasm_state;
      const secondItem = document.querySelector('.a-wizard-step:nth-child(2)');
      const thirdItem = document.querySelector('.a-wizard-step:nth-child(3)');

      if (currentAasmState !== undefined && currentAasmState !== 'open') {
        if (thirdGroup.includes(currentAasmState)) {
          thirdItem.classList.add(wizardActiveStep);
          this.wizard_status = 'resolved';
        } else {
          secondItem.classList.add(wizardActiveStep);
          this.wizard_status = 'review';
        }
      }
    },
    openInformationRequestTab() {
      document.querySelector('[id^="tab-information-request"].nav-link').click();
    },
    customFormat(value) {
      return dateService.customFormat(value);
    },
    getExpiredMessage() {
      switch (this.complaint.ticket_info.payment_method) {
        case 'PayPal':
          return 'Pasaron 3 meses desde que el reclamo fue aprobado y no se logró realizar el reembolso a través de Paypal';
        case 'Payu Crédito/Débito':
          return 'Pasaron 3 meses desde que el reclamo fue aprobado y no se logró realizar el reembolso a través de PayU';
        default:
          if (this.complaint.bank_account.bank === undefined) {
            return 'Pasaron 3 meses desde que el reclamo fue aprobado y el cliente no envió sus datos bancarios para realizar el reembolso';
          }
          return 'Pasaron 3 meses desde que se intentó realizar el reembolso pero los datos bancarios eran incorrectos y el cliente no los envió nuevamente';
      }
    },
  },
};
</script>

<style lang="scss">
  $recorrido-color: rgb(82, 207, 215);
  $small-breakpoint: 600px;
  $wizard-grey: #ebebeb;

  .has-error {
    color: red;
  }
  .update-message {
    background: {
      color: rgb(250, 217, 181);
    }
    padding: 4px 10px;
    border-radius: 4px;
    border: 1px solid $wizard-grey;
  }
  .complaint-category {
    background: {
      color: rgb(235, 235,235);
    }
    padding: 6px 10px;
    margin-left: 14px;
    position: relative;
    top: -6px;
    display: inline-block;
    font: {
      size: 12px;
    }
    @media screen and (max-width: $small-breakpoint) {
      display: block;
      margin: {
        top: 10px;
        left: 0;
      }
    }
  }
  .step-number {
    display: inline-block;
    padding: 0 6px;
    border-radius: 50%;
    border: 1px solid #000;
    font: {
      size: 12px;
    }
    margin: {
      right: 10px;
    }
    position: relative;
    top: -2px;
    @media screen and (max-width: $small-breakpoint) {
      display: none;
    }
  }
  .complaint-wizard-steps {
    padding: 0;
    display: flex;
    margin: 2rem 0;
    .a-wizard-step {
      background: {
        color: $wizard-grey;
      }
      display: inline;
      flex: 1;
      padding: {
        top: 6px;
        bottom: 6px;
      }
      position: relative;
      text-align: center;
      @media screen and (max-width: $small-breakpoint) {
        font: {
          size: 10px;
        }
      }
      &:last-child {
        &:after {
          background: white;
          right: 0;
        }
      }
      &:before,
      &:after {
        content: '';
        position: absolute;
        z-index: 1;
        border-style: solid;
        border-color: transparent;
        width: 0;
        height: 0;
      }
      &:after {
        right: -16px;
        top: 0;
        border-width: 18px 0 18px 16px;
        border-color: transparent transparent transparent $wizard-grey;
        @media screen and (max-width: $small-breakpoint) {
          border-width: 14px 0 13px 14px;
          right: -14px;
        }
      }
      &.active-step {
        background: {
          color: $recorrido-color;
        }
        &:after {
          border-color: transparent transparent transparent $recorrido-color;
        }
      }
    }
  }
  .complaint-category-container,
  .update-status {
    margin: {
      bottom: 22px;
    }
  }

  .public-header {
    position: absolute;
    top: 0;
    left: 15px;
    width: 100%;
    padding: {
      top: 20px;
      bottom: 20px;
    }
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
    & + .row {
      padding-top: 10px;
    }
    .recorrido-logo {
      max-width: 250px;
    }
  }
  .loading-section.fa-icon {
    margin: 0 auto;
    display: block;
    color: #777777;
  }
  .requested-information-notice {
    .request-icon {
      float: left;
      margin-right: 10px;
    }
  }
  .inline-dark-link {
    text: {
      decoration: underline;
    }
    color: darken(#212529, 20%);
  }
  .resolved-status-container {
    padding: {
      bottom: 20px;
    }
    h4 {
      margin: {
        bottom: 25px;
      }
    }
    h4,
    p {
      position: relative;
      padding: {
        left: 58px;
        top: 4px;
      }
    }
    p {
      img {
        top: 6px;
      }
    }
    img {
      position: absolute;
      left: 0;
      top: 0;
    }
    strong {
      display: inline-block;
    }
  }
  .disclaimer {
    padding: {
      top: 20px;
    }
  }
  .complaint-details-title {
    margin: {
      bottom: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/complaints/Status.vue